import { Types } from 'mongoose';
import z from 'zod';

export const ExperimentQuestionResultSchema = z.object({
  questionId: z.string(),
  question: z.string(),
  referenceAnswer: z.string(),
  newAnswer: z.string(),
  reasoning: z.string(),
  isCorrect: z.boolean(),
  promptTokens: z.number().nullish(),
  completionTokens: z.number().nullish(),
  totalTokens: z.number().nullish(),
  latencyMs: z.number().nullish(),
  langsmithRunUrl: z.string().nullish(),
});

export type TExperimentQuestionResult = z.infer<
  typeof ExperimentQuestionResultSchema
>;

const ExperimentResultBaseSchema = z.object({
  experimentName: z.string(),
  datasetName: z.string(),
  score: z.number().min(0).max(100),
  startDate: z.string(),
  endDate: z.string(),
  totalTokens: z.number().nullish(),
  totalPromptTokens: z.number().nullish(),
  totalCompletionTokens: z.number().nullish(),
  avgLatencyMs: z.number().nullish(),
  questionResults: z.array(ExperimentQuestionResultSchema),
});

export const ExperimentResultSchema = ExperimentResultBaseSchema.extend({
  _id: z.union([z.instanceof(Types.ObjectId), z.string()]),
});

export type TExperimentResult = z.infer<typeof ExperimentResultSchema>;

export const SaveExperimentResultSchema = ExperimentResultBaseSchema.extend({
  companyId: z.string(),
});

export type TSaveExperimentResult = z.infer<typeof SaveExperimentResultSchema>;
